import * as types from "./actionTypes";
import * as networkApi from "../../api/networkApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadNetworkSuccess(network) {
  return { type: types.LOAD_NETWORK_SUCCESS, network };
}

export function searchProfilesSuccess(profiles) {
  return { type: types.SEARCH_PROFILES_SUCCESS, profiles };
}

export function loadNetwork(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall())
    return networkApi
      .getNetwork(accessToken)
      .then((network) => {
        dispatch(loadNetworkSuccess(network));
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function addToNetwork(accessToken, id) {
  return function (dispatch) {
    dispatch(beginApiCall())
    return networkApi
      .addToNetwork(accessToken, id)
      .then((network) => {
        dispatch(loadNetworkSuccess(network));
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      })
  };
}

export function removeFromNetwork(accessToken, id) {
  return function (dispatch) {
    dispatch(beginApiCall())
    return networkApi
      .removeFromNetwork(accessToken, id)
      .then((network) => {
        dispatch(loadNetworkSuccess(network));
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      })
  };
}

export function searchProfiles(accessToken, searchInput, selectedCity) {
    return function (dispatch) {
      dispatch(beginApiCall());
      return networkApi
        .searchProfiles(accessToken, searchInput, selectedCity)
        .then(profiles => {
          dispatch(searchProfilesSuccess(profiles));
          console.log(profiles);
          return profiles;
        })
        .catch(error => {
          dispatch(apiCallError(error));
          throw error;
        });
    };
}